import {Pipe, PipeTransform} from '@angular/core';
import {GraphNodeModel} from "../models/graph-node.model";
import {GLOBAL} from "common-shared";

@Pipe({
  name: 'nodeLabel'
})
export class NodeLabelPipe implements PipeTransform {
  transform(node: GraphNodeModel): string {
    let label = node.label;
    if (node.Data?.Specs) {
      const source = node.Data.Specs[GLOBAL.Properties.Allikas];
      const sourceNr = node.Data.Specs[GLOBAL.Properties.AllikaNumber];
      if (source) {
        label = label + ': ' + source;
      }
      if (sourceNr) {
        label = label + '-' + sourceNr;
      }
    }

    if (label?.length > 30) {
      return label.substring(0, 27) + '...';
    }
    return label;
  }
}
